export default __webpack_public_path__ + "static/media/icon-accordion-arrow.21e328e6.svg";